import { useLayoutEffect } from "react";

const refCounts = new Map<string, number>();

/**
 * Adds the given class to <body> while the component is mounted.
 * Ref-counted so multiple components can request the same class
 * without one unmounting clobbering the others.
 */
export function useBodyClass(className: string): void {
  useLayoutEffect(() => {
    const next = (refCounts.get(className) ?? 0) + 1;
    refCounts.set(className, next);
    if (next === 1) {
      document.body.classList.add(className);
    }
    return () => {
      const remaining = (refCounts.get(className) ?? 1) - 1;
      if (remaining <= 0) {
        refCounts.delete(className);
        document.body.classList.remove(className);
      } else {
        refCounts.set(className, remaining);
      }
    };
  }, [className]);
}
